<template>
    <CicPopup
        v-if="showSelect && !$store.showLoadingOverlay"
        :title="$t('Number Groups')"
        :saveable="!!selected"
        @blur="close"
        @input="$emit('input', selected)"
    >
        <CicSelect
            id="access_point_group_select"
            :value="selected"
            :options="
                groups.filter((x) => voiceOnly || !x.voiceOnly).map((x) => ({ value: x.accessId, label: x.name }))
            "
            @input="(val) => (selected = val)"
        />
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicSelect from '@/components/inputs/CicSelect';
    import { load } from '@/utils/Http';

    export default {
        name: 'AccessPointGroupSelect',
        components: {
            CicSelect,
            CicPopup,
        },
        props: {
            orgId: {
                type: Number,
                required: true,
            },
            voiceOnly: {
                type: Boolean,
                default: true,
            },
        },
        emits: ['blur', 'input'],
        data() {
            return {
                selected: null,
                groups: null,
                showSelect: false,
            };
        },
        watch: {
            orgId() {
                this.loadGroups();
            },
        },
        methods: {
            close() {
                this.showSelect = false;
                this.$emit('blur');
            },
            loadGroups() {
                this.selected = null;
                if (this.orgId === 0) {
                    this.showSelect = false;
                } else if (
                    this.groups === null ||
                    (!this.voiceOnly && this.groups.length > 0 && !Object.keys(this.groups[0]).includes('voiceOnly'))
                ) {
                    if (!this.voiceOnly) {
                        load('accesspointgroups/getroutes', {}, (response) => {
                            this.groups = response.groups;
                            this.showSelect = true;
                        });
                    } else {
                        load('accesspointgroups/get', {}, (response) => {
                            this.groups = response.groups;
                            this.showSelect = true;
                        });
                    }
                } else {
                    this.showSelect = true;
                }
            },
        },
    };
</script>
